import React from 'react';
import './Ourbranches.css'; // Import the CSS file

const branches = [
  // Using a consistent building emoji as originally requested for simplicity
  { id: 1, name: 'Goa', emoji: '🏢' },
  { id: 2, name: 'Bihar', emoji: '🏢' }, // State, kept as requested
  { id: 3, name: 'Pune', emoji: '🏢' },
  { id: 4, name: 'Delhi', emoji: '🏢' },
  { id: 5, name: 'Mumbai', emoji: '🏢' },
  { id: 6, name: 'Dehradun', emoji: '🏢' },
  { id: 7, name: 'Hyderabad', emoji: '🏢' }, // Corrected spelling
  { id: 8, name: 'Bengaluru', emoji: '🏢' },
  { id: 9, name: 'Kolkata', emoji: '🏢' },
  { id: 10, name: 'Uttar Pradesh', emoji: '🏢' } ,// State, kept as requested
  { id: 11, name: 'West Bengal', emoji: '🏢' }, // State, kept as requested
  { id: 12, name: 'Chandigarh', emoji: '🏢' } // State, kept as requested
];

const BranchLocator = () => {
  return (
    <div className="locator-page">
      <h1 className="locator-title">Our Locations</h1>
      <p className="locator-subtitle">Find a branch near you</p>

      <div className="branch-grid-container">
        {branches.map((branch, index) => (
          <div
            key={branch.id}
            className="branch-card-simple"
            style={{ '--delay': `${index * 0.05}s` }} // Stagger animation delay
          >
            <div className="card-icon">{branch.emoji}</div>
            <h2 className="card-city">{branch.name}</h2>
            
          </div>
        ))}
      </div>
    </div>
  );
};

export default BranchLocator;